import ElementVisibilityToggleController from "controllers/element_visibility_toggle_controller"

export default class extends ElementVisibilityToggleController {
  static values = { target: String }

  toggle(event) {
    if (parseInt(event.target.value) === parseInt(this.targetValue) && event.target.checked) {
      this.toggleOn()
    } else {
      this.toggleOff()
    }
  }
}
